module.exports = __webpack_public_path__ + "static/steve-swain-39a4eeaaca8ac0a1e905fc1c12d896f9.png";